import Api from '@EntitySauce/Api'
import { createEntitySauce, EntitySauceProvider } from '@EntitySauce/helpers'
import routes from '@EntitySauce/Routes'

export const entitySauce = createEntitySauce(routes, Api)
export { EntitySauceProvider }
